import '../style/common/LoaderScreen.scss'
const LoaderScreen = (props) => {
    const { message = "Loading..." } = props;
    return (
        <div className='loader'>
            <Loader />
            <div className="loadingMessage">{message}</div>
        </div>
    )
}

export const Loader = () => (
    <div className='loading'>
        <span></span>
        <span></span>
        <span></span>
    </div>
)

export default LoaderScreen;